import {
  HeartHandshake,
  Waypoints,
  FileText,
  BarChart2,
  BriefcaseBusiness,
  Speech,
  SquareCode,
  Braces,
  BookOpenText
} from 'lucide-vue-next'

// Map icon strings to actual components
const iconComponents = {
  HeartHandshake,
  Waypoints,
  FileText,
  BarChart2,
  BriefcaseBusiness,
  Speech,
  SquareCode,
  Braces,
  BookOpenText
}

const curriculumSections = [
  {
    id: 3,
    name: '0. Onboarding',
    icon: 'HeartHandshake',
  },
  {
    id: 1,
    name: '1. Algorithms - core program',
    icon: 'Waypoints',
  },
  {
    id: 4,
    name: '3. Resume',
    icon: 'FileText',
  },
  {
    id: 18,
    name: '4. Negotiations preparation',
    icon: 'BarChart2',
  },
  {
    id: 7,
    name: '5. Applying to companies',
    icon: 'BriefcaseBusiness',
  },
  {
    id: 6,
    name: '6. Behavioral interviews',
    icon: 'Speech',
  },
  {
    id: 9,
    name: '9. [BONUS] Algorithms - Dynamic Programming',
    icon: 'SquareCode',
  },
  {
    id: 10,
    name: '10. [BONUS] Object-Oriented Programming',
    icon: 'Braces',
  },
  {
    id: 0,
    icon: "BookOpenText"
  }
]

/**
 * Get icon component for a curriculum section by name
 * @param sectionName Section name to look up
 * @returns The icon component or null if not found
 */
export const getSectionIcon = (sectionName?: string | null) => {
  if (!sectionName) return null
  
  // Try to find a section with matching name
  const sectionData = curriculumSections.find(section => section.name?.includes(sectionName))
  
  if (sectionData?.icon) {
    return iconComponents[sectionData.icon as keyof typeof iconComponents]
  }
  
  // Use fallback icon (section with id=0) if no match found
  const fallbackSection = curriculumSections.find(section => section.id === 0)
  return fallbackSection?.icon ? iconComponents[fallbackSection.icon as keyof typeof iconComponents] : null
}

export { iconComponents }
export default curriculumSections;